import { CHART_BAR_OPTIONS as optionsDefault } from './options-energia';
import {
  resultsetWithFields,
  printDataChart,
  printNoDataChart,
  initChart,
} from 'vlcishared';
import { ajustarEscalaEje, ID_ENERGIA_CONSUMIDA, ID_ENERGIA_VERTIDA } from './common-energia';
import {
  deepCloneWithFunctions,
  formatToDayMonthSlash,
  formatToMonthYearSlash,
} from './common-energia';
import { TEXTS_ENERGIA } from './texts';
import { DEFAULT_LANGUAGE } from '../common-language';

const ID_CHART_BAR_CONSUMIDA_DIARIA = 'chartBarEvolucionDiaria';
const ID_CHART_BAR_CONSUMIDA_MENSUAL = 'chartBarEvolucionMensual';

function actualizarOpcionesPorEvolucion(idChart, options) {
  const newOptions = deepCloneWithFunctions(options);  

  if (idChart === ID_CHART_BAR_CONSUMIDA_DIARIA) {
    newOptions.title.text = TEXTS_ENERGIA[DEFAULT_LANGUAGE].get(
      'energiaEvolucionDiaria',
    );
    newOptions.xAxis.axisLabel.formatter = formatToDayMonthSlash;
  } else if (idChart === ID_CHART_BAR_CONSUMIDA_MENSUAL) {
    newOptions.title.text = TEXTS_ENERGIA[DEFAULT_LANGUAGE].get(
      'energiaEvolucionMensual',
    );
    newOptions.xAxis.axisLabel.formatter = formatToMonthYearSlash;    
    //newOptions.yAxis[0].nameTextStyle.padding = [0,-65,0,0];
  } else {
    newOptions.title.text = TEXTS_ENERGIA[DEFAULT_LANGUAGE].get(
      'energiaEvolucionAnual',
    );  
    //newOptions.yAxis[0].nameTextStyle.padding = [0, -60, 0, 0];
  }

  return newOptions;
}

function obtenerSeriesPorTipoEnergia(categorias, datos, tipoEnergia) {
  return categorias.map((periodo) => {
    const f = datos.find(
      (d) => d.periodo === periodo && d.tipo_energia === tipoEnergia,
    );
    return f ? f.energia_total : 0;
  });
}

function configurarOpciones(resultSet) {
  const datosArray = Object.values(resultSet);
  const ejeX = [...new Set(datosArray.map((d) => d.periodo))];
  const serieConsumida = obtenerSeriesPorTipoEnergia(
    ejeX,
    datosArray,
    ID_ENERGIA_CONSUMIDA,
  );
  const serieVertida = obtenerSeriesPorTipoEnergia(
    ejeX,
    datosArray,
    ID_ENERGIA_VERTIDA,
  );

  const options = deepCloneWithFunctions(optionsDefault);
  const maxEjeY = ajustarEscalaEje(serieConsumida);
  options.yAxis[1].max = maxEjeY;
  options.series[0].data = serieConsumida;
  options.series[1].data = serieVertida;
  options.xAxis.data = ejeX;
  return options;
}

export function echartBarEvolucion(data, idChart, idNoData) {
  const resultSet = resultsetWithFields(data);
  if (resultSet.length === 0) {
    printNoDataChart(`#${idChart}`, `#${idNoData}`);
    return;
  }
  printDataChart(`#${idNoData}`, `#${idChart}`);

  let chartOptions = configurarOpciones(resultSet);
  chartOptions = actualizarOpcionesPorEvolucion(idChart, chartOptions);

  initChart(idChart, chartOptions);
}
